import { IDS } from "./pnp-approval-workflow/pnp-approval-workflow.constants";
import { PNP_ADD_APPROVERS_CONTACTS, PNP_ADD_REVIEWERS_CONTACTS, PNP_AUDIT_TYPES, PNP_CONTAINER_TYPES, PNP_DOCUMENT_CATEGORIES, PNP_DOCUMENT_RISK_LEVELS, PNP_REMOVE_APPROVERS_CONTACTS, PNP_REMOVE_REVIEWERS_CONTACTS , PNP_DEFAULT_CATEGORIES} from "./pnp-settings.actions.types";
import API from '../../../common/http/api.fetch';

export const getSettingsApprovalWorkflowCategories = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-categories`,
            method: 'GET',
            params: {
                offset: 0,
                limit: 100
            }
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_CATEGORIES,
                id: IDS.pnpSettingsApprovalWorkflow,
                items: response.data.items.map(({ name, location_name, dca_id , prefix }) => ({
                    value: dca_id,
                    label: `${name} - ( ${location_name} )`,
                    prefixName : prefix
                }))
            });
        });
    }
}

export const getSettingsApprovalWorkflowRiskLevels = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-risk-levels`,
            method: 'GET',
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_RISK_LEVELS,
                id: IDS.pnpSettingsApprovalWorkflow,
                items: response.data.map(item => {
                    return {
                        value: item.drl_id,
                        review_freq: item.review_freq,
                        label: item.risk_level_name,
                        unit: item.unit,
                        drl_id: item.drl_id
                    }
                })
            });
        });
    }
}

export const getSettingsApprovalWorkflowAuditTypes = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-audit-types`,
            method: 'GET',
        }).then((response) => {
            dispatch({
                type: PNP_AUDIT_TYPES,
                id: IDS.pnpSettingsApprovalWorkflow,
                items: response.data.map(item => {
                    return {
                        value: item.gty_id,
                        label: item.name,
                    }
                })
            });
        });
    }
}

export const getSettingsApprovalWorkflowContainerTypes = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-container-types`,
            method: 'GET',
        }).then((response) => {
            dispatch({
                type: PNP_CONTAINER_TYPES,
                id: IDS.pnpSettingsApprovalWorkflow,
                items: response.data.map(item => {
                    return {
                        value: item.sty_id,
                        label: item.name,
                    }
                })
            });
        });
    }
}

export const addReviewerContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_ADD_REVIEWERS_CONTACTS,
            id: 'pnpSettingsApprovalWorkflow',
            path: 'pnpSettingsApprovalWorkflow.selectedReviewers',
            item
        });
    };
};

export const removeReviewerContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_REMOVE_REVIEWERS_CONTACTS,
            id: 'pnpSettingsApprovalWorkflow',
            path: 'pnpSettingsApprovalWorkflow.selectedReviewers',
            item
        });
    };
};

export const addApporverContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_ADD_APPROVERS_CONTACTS,
            id: 'pnpSettingsApprovalWorkflow',
            path: 'pnpSettingsApprovalWorkflow.selectedApprovers',
            item
        });
    };
};

export const removeApproverContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_REMOVE_APPROVERS_CONTACTS,
            id: 'pnpSettingsApprovalWorkflow',
            path: 'pnpSettingsApprovalWorkflow.selectedApprovers',
            item
        });
    };
};

export const getSettingsDefaultCategories = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/default-categories`,
            method: 'GET',
        }).then((response) => {
            dispatch({
                type: PNP_DEFAULT_CATEGORIES,
                id: 'pnpSettingsDocumentCategory',
                items: response.data.map(({ name, location_name, dca_id, prefix }) => ({
                    value: dca_id,
                    label: name,
                    prefixName: prefix
                }))
            });
        });
    }
}
